import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DocType } from '@shared/models/doc-type.enum';
import { Policy } from '@shared/models/policy';
import { B2bFilterType } from '@shared/models/b2b-filter-type.enum';
import { PartnerDocument } from '@shared/models/partner-document';

import PartnerDocumentListMock from '@mocks/getPartnerDocumentList.json';
import PartnerDocumentListShortMock from '@mocks/getPartnerDocumentListShort.json';

@Injectable({
    providedIn: 'root'
})
export class B2bService {

    private partnerDocumentList: PartnerDocument[] = [];
    private partnerDocumentListShort: PartnerDocument[] = [];

    constructor(
        private commonService: CommonService,
        private http: HttpClient
    ) {
        this.partnerDocumentList = PartnerDocumentListMock;
        this.partnerDocumentListShort = PartnerDocumentListShortMock;
    }

    public getPartnerDocumentList(
        policyNumber: string,
        dateFrom: string | null,
        dateTo: string | null,
        filterType: B2bFilterType,
        docType: DocType
    ): Observable<PartnerDocument[]> {
        if (this.commonService.useMocks) {
            return new Observable(observer => observer.next(this.partnerDocumentList));
        }

        let params = {
            policyNumber: policyNumber,
            docType: docType,
            filterType: filterType
        };
        if (dateFrom) {
            params['dateFrom'] = dateFrom;
        }

        if (dateTo) {
            params['dateTo'] = dateTo;
        }

        return this.http.get<PartnerDocument[]>(this.commonService.getServiceUrl('partner-document/list'), {
            params: params
        });
    }

    public getPartnerDocumentPartList(
        policyNumber: string,
        mainDocId: string
    ): Observable<PartnerDocument[]> {

        if (this.commonService.useMocks) {
            return new Observable(observer => observer.next(this.partnerDocumentListShort));
        }

        return this.http.get<PartnerDocument[]>(this.commonService.getServiceUrl('partner-document/part-list'), {
            params: {
                policyNumber: policyNumber,
                mainDocId: mainDocId
            }
        });
    }

    public getProductName(policy: Policy): string {
        if (policy.policyNumber.startsWith('805')) {
            return 'Leasingová zmluva PZP';
        }

        if (policy.policyNumber === '7050002266') {
            return 'Leasing kasko značkové';
        }

        if (policy.policyNumber === '7050002306') {
            return 'Leasing kasko neznačkové';
        }

        if (policy.policyNumber.startsWith('705')) {
            return 'Leasingová zmluva KASKO';
        }

        if (policy.policyNumber.startsWith('795')) {
            return 'Leasingová zmluva GAP';
        }

        return '';
    }
}
